export const sanitizeZipCodeInput = (value: string): string =>
  value.replace(/\D/g, "").slice(0, 5);

export const sanitizeCityInput = (value: string): string =>
  value.replace(/[^\p{L}\s.'-]/gu, "");
